import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { FaChevronDown } from "react-icons/fa";
import logo from "../../../loghi/logo_4.svg";

import Link from "../../Link/Link";

import "./TopFooter.scss";
import Phone from "../../Icons/Phone";
import MetodiPagamento from "../../Icons/MetodiPagamento";
import Spedizionieri from "../../Icons/Spedizionieri_2";

const TopFooter = ({
  isCheckout,
  datiFarmacia,
  logoImage,
  siteName,
  primaryColor,
  showDiscountsLinkInFooter,
}) => {
  const menu = [
    {
      id: 1,
      title: siteName,
      content: [
        {
          id: 1,
          link: "/registrazione",
          title: "Registrati gratuitamente",
        },
        {
          id: 2,
          link: "/pagine/contattaci",
          title: "Contattaci",
        },
      ],
    },
    {
      id: 2,
      title: "Informazioni",
      content: [
        {
          id: 1,
          link: "/pagine/condizioni-vendita",
          title: "Condizioni di vendita",
        },
        {
          id: 2,
          link: "/pagine/modalita-costi-spedizione",
          title: "Modalità e costi spedizione",
        },
        {
          id: 3,
          link: "/pagine/diritto-recesso",
          title: "Diritto di recesso",
        },
        {
          id: 4,
          link: "/pagine/pagamenti-accettati",
          title: "Pagamenti accettati",
        },
      ],
    },
    {
      id: 3,
      title: "Garanzie",
      content: [
        {
          id: 1,
          link: "/pagine/diritto-recesso",
          title: "Soddisfatti o rimborsati",
        },
        {
          id: 2,
          link: "/pagine/informativa-privacy",
          title: "Come tuteliamo la tua privacy",
        },
        {
          id: 3,
          link: "/pagine/chi-siamo",
          title: "Chi siamo",
        },
      ],
    },
    {
      id: 4,
      title: "Promozioni",
      content: [
        {
          id: 1,
          link: "/prodotti-in-offerta",
          title: "Tutte le offerte",
        },
      ],
    },
  ];

  return (
    <div className="top-footer">
      <div className="container">
        {/* DESKTOP */}
        <div className="desktop-footer-menu">
          <div className="address-menu">
            <div className="col-address">
              <img src={logo} alt={siteName} className="logo" />
              <address>
                {datiFarmacia.address1}
                {datiFarmacia.address2 && " " + datiFarmacia.address2}
                {datiFarmacia.zipcode && " - " + datiFarmacia.zipcode}
                {datiFarmacia.city && " " + datiFarmacia.city}
                {datiFarmacia.province && " (" + datiFarmacia.province + ")"}
                <br />
                035 000000
                <br />
                <div>P. IVA 040000000000</div>
              </address>
            </div>

            {!!menu &&
              menu.map((col) => {
                return (
                  <div className="col-menu" key={col.id}>
                    {!isCheckout && (
                      <React.Fragment>
                        <h4>{col.title}</h4>
                        <ul>
                          {col.content.map((item) => {
                            return (
                              <li key={item.id}>
                                <Link to="#">{item.title}</Link>
                              </li>
                            );
                          })}
                        </ul>
                      </React.Fragment>
                    )}
                  </div>
                );
              })}

            <div className="col-phone">
              <h3>
                <Phone />
                035 000000
              </h3>
            </div>
          </div>
        </div>

        {/* MOBILE */}
        <div className="mobile-footer-menu">
          <div className="address-menu">
            <div className="col-address">
              <img src={logoImage} alt={siteName} className="logo" />
              <address>
                {datiFarmacia.address1}
                {datiFarmacia.address2 && " " + datiFarmacia.address2}
                {datiFarmacia.zipcode && " - " + datiFarmacia.zipcode}
                {datiFarmacia.city && " " + datiFarmacia.city}
                {datiFarmacia.province && " (" + datiFarmacia.province + ")"}
                <br />
                {datiFarmacia.phone}{" "}
                {datiFarmacia.phone2 && " - " + datiFarmacia.phone2}
                <br />
                <div>P. IVA {datiFarmacia.vatCode}</div>
              </address>
            </div>
            <div className="col-phone">
              <h3>
                <Phone />
                <a
                  href={"tel:" + datiFarmacia.phone}
                  style={{ color: "white" }}
                >
                  {datiFarmacia.phone}
                </a>
              </h3>
            </div>
          </div>
          {!!menu && !isCheckout && (
            <Accordion allowZeroExpanded allowMultipleExpanded>
              {menu.map((col) => {
                return (
                  <AccordionItem key={col.id}>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <h4>
                          {col.title} <FaChevronDown />
                        </h4>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <ul>
                        {col.content.map((item) => {
                          return (
                            <li key={item.id}>
                              <Link to={item.link}>{item.title}</Link>
                            </li>
                          );
                        })}
                      </ul>
                    </AccordionItemPanel>
                  </AccordionItem>
                );
              })}
            </Accordion>
          )}
        </div>

        <div className="info">
          <div className="pagamenti">
            <h4>Pagamenti sicuri</h4>
            <MetodiPagamento />
          </div>
          <div className="spedizioni">
            <h4>Spedizioni rapide</h4>
            <Spedizionieri />
          </div>
        </div>

        {/* <hr />

        <div>
          <h4 className="mb-0">Siamo presenti su</h4>
        </div> */}
      </div>
    </div>
  );
};

export default TopFooter;
